import { render, staticRenderFns } from "./UploadModule.vue?vue&type=template&id=a60fa3f4&"
import script from "./UploadModule.vue?vue&type=script&lang=js&"
export * from "./UploadModule.vue?vue&type=script&lang=js&"
import style0 from "./UploadModule.vue?vue&type=style&index=0&scope=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports